export const PASS = 'pass';
export const FAIL = 'fail';
export const SKIPPED = 'skipped';



// WEBPACK FOOTER //
// ./app/constants/quizStatus.js